import * as ActionTypes from './actionTypes.js';
var _ = require('lodash');

export default function messageReducers(state = {}, action) {
    switch (action.type) {
        case ActionTypes.ERROR_MESSAGE:
        case ActionTypes.DEFAULT_MESSAGE:
        case ActionTypes.INFORMATION_MESSAGE:
            return _.extend({}, state, action.payload, { cleared: false });
        case ActionTypes.CLEAR_MESSAGE:
            return _.extend({}, state, action.payload, { cleared: true });
        default:
            return state;
    }
}